import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SpinnerService } from '../../_components/spinner/spinner.service';
import { AuthService, CostaAppService, HomeService } from '../../_services';
import { Constants, SessionStoragerService } from '../../_utility';
import { Router } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { Companion, CompanionType, Restaurant } from '../../_models';
import { MessageService } from 'primeng/api';

@Component({
  standalone: false,
  selector: 'app-select-user',
  templateUrl: './select-user.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class SelectUserComponent implements OnInit {
  public restaurant!: Restaurant;
  public datasource: Array<Companion> = [];
  public selectedCompanions: Array<Companion> = [];
  diningWith: boolean = false;
  autologin: boolean = true;
  public noBookableSlots: boolean = false;
  public phone_number: string = '5555';

  constructor(
    private router: Router,
    private auth: AuthService,
    private service: HomeService,
    private spinner: SpinnerService,
    private sStore: SessionStoragerService,
    private costaApp: CostaAppService
  ) {
    let temp = this.sStore.getElement(Constants.Storager.RESTAURANT);
    if (!!temp) {
      this.restaurant = temp;
    } else {
      this.router.navigate(Constants.Routing.HOME.routerLink);
    }
    let phone_number = this.sStore.getElement(Constants.Storager.PHONE_NUMBER);
    if (!!phone_number) {
      this.phone_number = phone_number;
    }
  }

  ngOnInit(): void {
    this.autologin = this.sStore.getElement(Constants.Storager.AUTOLOGIN);
    if (!!this.restaurant) {
      this.spinner.show();
      this.service
        .Passengers(this.auth.user!.email!, this.restaurant.uuid_restaurant!)
        .subscribe({
          next: (res) => {
            this.noBookableSlots = res.length === 0;
            res.forEach((el: Companion, index: number) => {
              let name = [];
              name.push(el.name!.substring(0, 1));
              name.push(el.surname!.substring(0, 1));
              el.inizialiNome = name.join('');
              if (index === 0) {
                el.selected = true;
                this.selectedCompanions.push(el);
              } else {
                el.selected = false;
              }

              this.datasource.push(el);

              if (el.companion_type === CompanionType.diningWith) {
                this.diningWith = true;
              }
            });
            this.spinner.hide();
          },
        });
    }
  }

  Back() {
    this.router.navigate(Constants.Routing.HOME.routerLink);
  }

  Close() {
    this.costaApp.close();
    if (!this.autologin) {
      this.auth.SignOut();
    }
  }

  Select(profile: Companion): void {
    if (profile.attribute! == 'passenger.attribute.you') {
      return;
    }
    profile.selected = !profile.selected;
    if (this.selectedCompanions.includes(profile)) {
      const index: number = this.selectedCompanions.indexOf(profile);
      this.selectedCompanions.splice(index, 1);
    } else {
      this.selectedCompanions.push(profile);
    }
  }

  Proceed() {
    if (this.selectedCompanions.length > 0) {
      this.sStore.setElement(
        Constants.Storager.COMPANIONS,
        this.selectedCompanions
      );
      this.router.navigate(Constants.Routing.CALENDAR.routerLink);
    }
  }
}
